/**
 * KB-META
 * Purpose: Polyfills
 * Role: ui.module
 * EntryPoints: 
 * Inputs: 
 * Outputs: 
 * Validation: 
 * Dependencies: 
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=src/polyfills; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
// This file includes polyfills needed by Angular and is loaded before the app.
// You can add your own extra polyfills to this file.

// Zone JS is required by default for Angular itself.
import 'zone.js';  // Included with Angular CLI.

// Add global object polyfill for amazon-cognito-identity-js
(window as any).global = window;
(window as any).process = {
  env: { DEBUG: undefined },
  version: '',
  // nextTick: require('next-tick')
}; 